import { Link } from "react-router-dom";

export function LandingPageFooter() {
  const handleScroll = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      window.history.pushState(null, null, `/#${id}`);
    }
  };

  return (
    <footer id="contact" className="lp-py-16 lp-px-6 lp-border-t lp-bc-b06 lp-relative lp-z-10" style={{ background: "var(--lp-color-footer-bg)" }}>
      <div className="lp-max-6xl lp-mx-auto">
        <div className="lp-grid lp-grid-cols-1 sm-cols-2 md-cols-4 lp-gap-8 lp-mb-12">
          
          {/* Column 1: Brand details */}
          <div>
            <span
              className="lp-text-dark lp-text-2xl lp-block lp-mb-4"
              style={{ fontFamily: "'Fraunces', serif", fontWeight: 600, letterSpacing: "-0.02em" }}
            >
              hub<span className="lp-text-blue">scroll</span>
            </span>
            <p 
              className="lp-text-muted lp-text-sm lp-leading-relaxed"
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
            >
              Discover the best cafés, restaurants, and nightlife across the UAE.
            </p>
          </div>

          {/* Column 2: Product */}
          <div>
            <h4 
              className="lp-text-dark lp-text-xs lp-uppercase lp-tracking-wider lp-font-medium lp-mb-4"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Product
            </h4>
            <ul className="lp-flex lp-flex-col lp-gap-2 lp-text-sm lp-text-muted" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li>
                <a href="#discover" onClick={(e) => handleScroll(e, "discover")} className="lp-transition-colors lp-hov-dark">
                  Discover
                </a>
              </li>
              <li>
                <a href="#discover" onClick={(e) => handleScroll(e, "discover")} className="lp-transition-colors lp-hov-dark">
                  Features
                </a>
              </li>
              <li>
                <a href="#download" onClick={(e) => handleScroll(e, "download")} className="lp-transition-colors lp-hov-dark">
                  Download App
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Business */}
          <div>
            <h4 
              className="lp-text-dark lp-text-xs lp-uppercase lp-tracking-wider lp-font-medium lp-mb-4"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Business
            </h4>
            <ul className="lp-flex lp-flex-col lp-gap-2 lp-text-sm lp-text-muted" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li>
                <Link to="/sign-in" className="lp-transition-colors lp-hov-dark">
                  List Your Venue
                </Link>
              </li>
              <li>
                <Link to="/contact" className="lp-transition-colors lp-hov-dark">
                  Partner With Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal */}
          <div>
            <h4 
              className="lp-text-dark lp-text-xs lp-uppercase lp-tracking-wider lp-font-medium lp-mb-4"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Legal
            </h4>
            <ul className="lp-flex lp-flex-col lp-gap-2 lp-text-sm lp-text-muted" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li>
                <Link to="/privacy-policy" className="lp-transition-colors lp-hov-dark">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="lp-transition-colors lp-hov-dark">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom copyright bar */}
        <div className="lp-border-t lp-bc-b06 lp-pt-8 lp-flex lp-flex-col sm-flex-row lp-justify-between lp-items-center lp-gap-4">
          <p className="lp-text-xs lp-text-muted" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>
            © 2026 HubScroll · Built for the UAE Hospitality Scene
          </p>
          <div className="lp-flex lp-gap-4 lp-text-muted lp-text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>
            <span>Dubai</span>
            <span>·</span>
            <span>Abu Dhabi</span>
            <span>·</span>
            <span>Sharjah</span>
          </div>
        </div>

      </div>
    </footer>
  );
}
